module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"total":"Total : {0}","valid":"Valid : {0}%"},"fr":{"total":"Total : {0}","valid":"Valide : {0}%"}}')
  delete Component.options._Ctor
}
